import React from 'react';

function CompareTray({ compareList, setShowComparePanel, user, removeFromCompare, clearCompare }) {
  
  if (compareList.length === 0) {
    return null;
  }

  const maxCompare = user?.tier === 'free' ? 2 : 3;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: '#1e293b',
      color: 'white',
      padding: '12px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      zIndex: 900,
      boxShadow: '0 -4px 20px rgba(0,0,0,0.3)'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
        <span style={{ fontWeight: '600', fontSize: '14px' }}>
          Compare ({compareList.length}/{maxCompare}):
        </span>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          {compareList.map(p => (
            <div key={p.id} style={{
              backgroundColor: '#334155',
              padding: '6px 12px',
              borderRadius: '4px',
              fontSize: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              maxWidth: '200px'
            }}>
              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {p.id}
              </span>
              <button
                onClick={() => removeFromCompare(p.id)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#94a3b8',
                  cursor: 'pointer',
                  padding: '0',
                  fontSize: '14px',
                  lineHeight: 1
                }}
              >
                x
              </button>
            </div>
          ))}
        </div>
      </div>
      <div style={{ display: 'flex', gap: '12px' }}>
        <button
          onClick={clearCompare}
          style={{
            backgroundColor: '#475569',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '13px'
          }}
        >
          Clear
        </button>
        <button
          onClick={() => setShowComparePanel(true)}
          disabled={compareList.length < 2}
          style={{
            backgroundColor: compareList.length < 2 ? '#475569' : '#8b5cf6',
            color: 'white',
            border: 'none',
            padding: '8px 20px',
            borderRadius: '6px',
            cursor: compareList.length < 2 ? 'not-allowed' : 'pointer',
            fontSize: '13px',
            fontWeight: '600'
          }}
        >
          View Comparison
        </button>
      </div>
    </div>
  );
}

export default CompareTray;
